import LivedigitalSDKError from './LivedigitalSDKError';

class AlreadyConnectedError extends LivedigitalSDKError {
  static readonly DEFAULT_MESSAGE = 'Peer is already connected';

  constructor(msg?: string, errorCode?: string, meta?: Record<string, unknown>) {
    super(msg ?? AlreadyConnectedError.DEFAULT_MESSAGE, errorCode ?? 'already_connected', meta);
  }
}

export default AlreadyConnectedError;
